import { Component, CSSProperties } from 'react';

type SwaggerAPIProps = {
  style?: CSSProperties;
};

class SwaggerAPI extends Component<SwaggerAPIProps> {
  render() {
    const { style } = this.props;

    return (
      <iframe
        id="iFrameSwaggerAPI"
        src={`${process.env.REACT_APP_URL_API_API}doc/swagger`}
        title="DISGENET REST API Swagger"
        style={{
          width: '100%',
          height: '1000px',
          backgroundColor: 'black',
          ...style,
        }}
      />
    );
  }
}

export default SwaggerAPI;
